import './static/iframeResizer.contentWindow.min.js';
import * as React from 'react';
import { createRoot } from 'react-dom/client';
import '@teliaee/payment-react-component/styles/styles.payment-component.css';

import App from './App';

const render = (AppComponent: React.ComponentClass) => {
  const root = createRoot(document.getElementById('container'));

  root.render(<AppComponent />);
};

render(App);
